import React from "react";
import Heading from "./Heading";
import { drink } from "./drinksData";

function Drinks() {
  return (
    <>
      <a href="#" id="drinks"></a>
      <div className="w-full p-4 h-fit font-fancy">
        <Heading heading="Drinks" />
        {drink.map((drink) => {
          return (
            <React.Fragment key={drink.id}>
              <div className="flex justify-between p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-base font-bold">{drink.name}</h3>
                <p className="px-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                  {drink.price}
                </p>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default Drinks;
